module.exports = __webpack_public_path__ + "static/bradesco-logo-65d74607e767ea91abd75c5a3f2fb878.png";